import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Autocomplete,
  Checkbox,
  Chip,
  Tooltip,
} from "@mui/material";
import { createFilterOptions } from "@mui/material/Autocomplete";
import {
  Notes,
  RadioButtonChecked,
  LabelOutlined,
} from "@mui/icons-material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { v4 as uuidv4 } from "uuid";
import React, { useState, useEffect } from "react";

export default function SuggestionAnswerComponent({
  id = 0,
  question = "Pergunta",
  type = 0,
  options = [],
  onChange = () => {},
  index = 0,
  remove = () => {},
  add = () => {},
}) {
  const theme = useTheme();
  const styles = useStyles(theme);

  const [value, setValue] = useState(options || []);
  const [optionsAutocomplete, setOptionAutocomplete] = useState(options || []);
  const filter = createFilterOptions();

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  useEffect(() => {
    onChange(id, "options", value);
  }, [value]);

  const handleChange = (event) => {
    onChange(id, "type", event.target.value);
    if (event.target.value !== 2) {
      setValue([]);
    }
  };

  return (
    <Paper variant="outlined" elevation={0} sx={styles.paperComponent}>
      <TextField
        sx={{ width: "100%", height: "100%" }}
        variant="filled"
        label="Pergunta"
        multiline
        rows={2}
        value={question}
        onChange={(event) =>
          onChange(id, "question", event.target.value)
        }
      />
      <Box sx={styles.boxTypeResposta}>
        <FormControl fullWidth>
          <InputLabel sx={{ top: 10 }} id="demo-simple-select-label">
            Tipo de resposta
          </InputLabel>
          <Select
            variant="filled"
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={type}
            label="Tipo de resposta"
            onChange={handleChange}
            size="small"
          >
            <MenuItem value={0}>
              <Box sx={styles.containerMenuItem}>
                <LabelOutlined sx={{ color: theme.palette.info.main }} />
                <Typography>Categoria</Typography>
              </Box>
            </MenuItem>

            <MenuItem value={1}>
              <Box sx={styles.containerMenuItem}>
                <Notes sx={{ color: theme.palette.primary.main }} />
                <Typography>Texto Longo</Typography>
              </Box>
            </MenuItem>
            
            <MenuItem value={2}>
              <Box sx={styles.containerMenuItem}>
                <RadioButtonChecked sx={{ color: theme.palette.success.main }} />
                <Typography>Caixa de seleção</Typography>
              </Box>
            </MenuItem>
          </Select>
        </FormControl>

        <Box sx={{ p: 1 }}>
          {type === 0 && (
            <Typography color="textSecondary" sx={{ ml: 1 }}>
              Categorias predefinidas (Bug, Melhoria, UX, etc.) serão exibidas.
            </Typography>
          )}
          {/* {type === 1 && (
            <TextField
              disabled
              variant="standard"
              placeholder="Texto de resposta longa"
              sx={{ width: "100%", ml: 1 }}
            />
          )} */}
          {type === 2 && (
            <Box sx={{ mt: 2 }}>
              <Autocomplete
                multiple
                freeSolo
                options={optionsAutocomplete}
                getOptionLabel={(option) =>
                  typeof option === "string" ? option : option.option
                }
                size="small"
                value={value}
                isOptionEqualToValue={(opt, val) =>
                  opt?.option?.toLowerCase() === val?.option?.toLowerCase()
                }
                renderOption={(props, option, { selected }) => (
                  <li {...props}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {typeof option === "string" ? option : option.option}
                  </li>
                )}
                onChange={(event, newValue, reason) => {
                  if (reason === "removeOption") {
                    setValue(newValue);
                    return;
                  }

                  const lastItem = newValue[newValue.length - 1];

                  let inputValue = "";

                  if (typeof lastItem === "string") {
                    if (lastItem.startsWith("Criar '") && lastItem.endsWith("'")) {
                      inputValue = lastItem.slice(7, -1).trim();
                    } else {
                      inputValue = lastItem.trim();
                    }
                  } else {
                    inputValue = lastItem?.option?.trim();
                  }

                  if (!inputValue) {
                    return;
                  }

                  const jaExiste = optionsAutocomplete.find(
                    (opt) =>
                      opt?.option?.toLowerCase() === inputValue?.toLowerCase()
                  );

                  const jaSelecionado = value.find(
                    (v) => v?.option?.toLowerCase() === inputValue?.toLowerCase()
                  );

                  if (jaSelecionado) {
                    setValue(
                      value.filter(
                        (v) =>
                          v?.option?.toLowerCase() !== inputValue?.toLowerCase()
                      )
                    );
                  } else if (jaExiste) {
                    setValue([...value, jaExiste]);
                  } else {
                    const novoItem = {
                      id: uuidv4(),
                      option: inputValue?.trim(),
                    };

                    setOptionAutocomplete((prev) => [...prev, novoItem]);
                    setValue([...value, novoItem]);
                  }
                }}
                filterOptions={(opts, params) => {
                  const filtered = filter(opts, params);
                  const input = params.inputValue.trim();

                  if (
                    input !== "" &&
                    !opts.some(
                      (opt) => opt?.option?.toLowerCase() === input?.toLowerCase()
                    )
                  ) {
                    filtered.push(`Criar '${input}'`);
                  }

                  return filtered;
                }}
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Tooltip title={option.option} key={option.id}>
                      <Chip
                        variant="outlined"
                        label={option.option}
                        {...getTagProps({ index })}
                      />
                    </Tooltip>
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    variant="filled"
                    {...params}
                    label="Opções de seleção"
                    placeholder="Adicionar"
                    autoComplete="off"
                    sx={{
                      "& .MuiInputBase-root": {
                        paddingTop: "20px",
                      },
                      "& .MuiInputLabel-root": {
                        top: "-3px",
                      },
                    }}
                  />
                )}
              />
            </Box>
          )}
        </Box>
      </Box>
    </Paper>
  );
}
